export class FvmsNoticeInfo {
    noticeId:number;//noticeId;
    title:string;
    content:string;//notice_msg
    viewCnt:number;//조회수
    noticeType:string;//noticeType 공지사항구분
    noticeTarget:string;//noticeTarget; 공지 대상 사용자 종류 
    popupYn:string;//popupyn;
    popupDtTo:string;//popupDtTo;
    ppopupDtFrom:string;//popupDtFrom;

}
